import { SearchBar } from '../../../components/sections';
import EscapeHatch from '../EscapeHatch/EscapeHatch';
import React from 'react';
import { SearchContentProps } from '../../../components/sections/search-bar/hooks/use-search-content';
import { OwnerManualProps } from '../../pages/owner-manual/hook/use-owner-manual-content';
import { HelpCardsProps } from '../../../views/page-not-found-view/hooks/use-help-cards-content';

interface Props {
    isAiSearch: boolean;
    ownerManualContent: OwnerManualProps;
    searchContent: SearchContentProps | null;
    helpCardsContent: HelpCardsProps;
}

const ownerManualEscapeHatch = (props: Props) => {
    const { searchContent, ownerManualContent, helpCardsContent } = props;
    return (
        <>
            {props.isAiSearch && ownerManualContent.aiSearchTitle ? (
                <div className="om-escape-hatch-with-search-bar">
                    {searchContent && helpCardsContent && (
                        <SearchBar
                            searchContent={searchContent}
                            helpCardsContent={helpCardsContent}
                        />
                    )}
                </div>
            ) : (
                <EscapeHatch />
            )}
        </>
    );
};

export default ownerManualEscapeHatch;
